import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const { ui } = constants.colors;

const greyColor = ui.neutral[500];
const greyLightColor = ui.neutral[100];
const greyExtraLightColor = ui.neutral[25];
const coreBlueColor = ui.core[500];
const whiteColor = ui.white[100];
const SPACER_HEIGHT = "144px";
export const SIDE_NAV_WIDTH = "270px";

const commonNavContainerStyles = {
  boxShadow: "6px 2px 12px 0 rgb(0 0 0 / 10%)",
  gridArea: "sideNavigation",
  maxWidth: SIDE_NAV_WIDTH,
  position: "relative",
};

export const newNavContainer = {
  ...commonNavContainerStyles,
  [mediaQuery.upTo(constants.breakpoints.BreakpointNames.sm)]: {
    bottom: 0,
    position: "fixed",
    maxWidth: "100vw",
    width: "100%",
    zIndex: 2,
  },
};

export const navItem = {
  alignContent: "space-between",
  alignItems: "baseline",
  borderTop: "4px solid transparent",
  display: "flex",
  justifyContent: "space-between",
  paddingRight: 16,
  ":hover": {
    backgroundColor: greyExtraLightColor,
  },
  [mediaQuery.downTo(constants.breakpoints.BreakpointNames.sm)]: {
    borderLeft: "4px solid transparent",
    borderTop: 0,
    transition: "all cubic-bezier(.25,.1,.25,1) 0.1s",
  },
};

export const navItemActive = {
  backgroundColor: greyExtraLightColor,
  borderTop: `4px solid ${coreBlueColor}`,
  [mediaQuery.downTo(constants.breakpoints.BreakpointNames.sm)]: {
    borderLeft: `4px solid ${coreBlueColor}`,
    borderTop: "none",
  },
};

export const navItemLink = {
  color: greyColor,
  display: "block",
  margin: "0 8px 8px",
  outlineOfsset: "-5px",
  padding: "8px",
  textDecoration: "none",
  transition: "color cubic-bezier(.25,.1,.25,1) .1s",
  whiteSpace: "nowrap",
  [mediaQuery.downTo(constants.breakpoints.BreakpointNames.sm)]: {
    margin: 0,
    outlineOfsset: "-10px",
    padding: "8px 28px 8px 40px",
    whiteSpace: "normal",
  },
};

export const navList = {
  [mediaQuery.downTo(constants.breakpoints.BreakpointNames.sm)]: {
    height: `calc(100vh - ${SPACER_HEIGHT})`,
    flexDirection: "column",
    margin: "8px 0 0 0",
    overflowY: "auto",
    padding: `0 0 ${SPACER_HEIGHT} 5px`,
    position: "sticky",
    top: 0,
  },
  backgroundColor: whiteColor,
  display: "flex",
  flexDirection: "row",
  listStyleType: "none",
  margin: 0,
  overflowX: "auto",
  padding: 0,
};

export const navSpacer = {
  backgroundColor: whiteColor,
  bottom: 0,
  borderTop: `1px solid ${greyLightColor}`,
  display: "block",
  minHeight: SPACER_HEIGHT,
  maxWidth: SIDE_NAV_WIDTH,
  position: "fixed",
  width: "100%",
  [mediaQuery.upTo(constants.breakpoints.BreakpointNames.sm)]: {
    display: "none",
  },
};
